import { AlignmentViewLayout } from "@/store/modes/alignment-ui-types";
import { selectCloudCadAlignmentLayout } from "@/store/modes/cloud-cad-alignment-mode-selectors";
import { useAppSelector } from "@/store/store-hooks";
import {
  IElementGenericPointCloudStream,
  IElementModel3dStream,
} from "@faro-lotv/ielement-types";
import type { JSX } from "react";
import { Box3 } from "three";
import { useOverlayElements } from "../overlay-elements-context";
import { AlignCloudCadOverlayScreen } from "./cloud-cad-alignment-overlay-scene";
import { AlignCloudCadSplitScreen } from "./cloud-cad-split-scene";

type AlignCloudCadSceneProps = {
  /** The cloud used for the alignment (either as reference or as aligned element) */
  activeCloud: IElementGenericPointCloudStream;

  /** The cad model used for alignment (either as reference or as aligned element) */
  activeCad: IElementModel3dStream;

  /** The bounding box of the cad model in world */
  cadBox: Box3;
};

/** @returns the scene for align the cloud to cad in 2d */
export function AlignCloudCadScene({
  activeCloud,
  activeCad,
  cadBox,
}: AlignCloudCadSceneProps): JSX.Element {
  const alignmentLayout = useAppSelector(selectCloudCadAlignmentLayout);
  const { firstScreen, secondScreen } = useOverlayElements();

  return alignmentLayout === AlignmentViewLayout.splitScreen &&
    firstScreen &&
    secondScreen ? (
    <AlignCloudCadSplitScreen
      {...{ activeCloud, activeCad, cadBox, firstScreen, secondScreen }}
    />
  ) : (
    <AlignCloudCadOverlayScreen {...{ activeCloud, activeCad, cadBox }} />
  );
}
